import { ClientNames } from '@procom-labs/common'

import { IClientLogoSize, LogoSizeOptions } from '@auth-portal/types'

export const ClientLogoSizes: Array<IClientLogoSize> = [
  {
    size: LogoSizeOptions.XLarge,
    clientSettingName: ClientNames.EY,
  },
]
